
export interface ClassYear {
  value: string;
  label: string;
  image?: string;
}

export const classYears: ClassYear[] = [
  {
    value: '12A1',
    label: '12A1',
    image: '/kyyeu/12A1.jpg'
  },
  {
    value: '12A2',
    label: '12A2',
    image: '/kyyeu/12A2.jpg'
  },
  {
    value: '12A3',
    label: '12A3',
    image: '/kyyeu/12A3.jpg'
  },
  {
    value: '12A4',
    label: '12A4',
    image: '/kyyeu/12A4.jpg'
  },
  {
    value: '12A5',
    label: '12A5',
    image: '/kyyeu/12A5.jpg'
  },
  {
    value: '12A6',
    label: '12A6',
    image: '/kyyeu/12A6.jpg'
  },
  {
    value: '12A7',
    label: '12A7',
    image: '/kyyeu/12A7.jpg'
  },
  {
    value: '12A8',
    label: '12A8',
    image: '/kyyeu/12A8.jpg'
  },
  {
    value: '12C',
    label: '12C',
    image: '/kyyeu/12C.jpg'
  },
  {
    value: '12CA',
    label: '12CA',
    image: '/kyyeu/12CA.jpg'
  },
  {
    value: '12CH',
    label: '12CH',
    image: '/kyyeu/12CH.jpg'
  },
  {
    value: '12CL',
    label: '12CL',
    image: '/kyyeu/12CL.jpg'
  },
  {
    value: '12CS_B',
    label: '12CS_B',
    image: '/kyyeu/12CS_B.jpg'
  },
  {
    value: '12CT',
    label: '12CT',
    image: '/kyyeu/12CT.jpg'
  },
  {
    value: '12CTC',
    label: '12CTC',
    image: '/kyyeu/12CTC.jpg'
  },
  {
    value: '12CTin',
    label: '12CTin',
    image: '/kyyeu/12CTin.jpg'
  },
  {
    value: '12D1',
    label: '12D1',
    image: '/kyyeu/12D1.jpg'
  },
  {
    value: '12D2',
    label: '12D2',
    image: '/kyyeu/12D2.jpg'
  },
  {
    value: '12D3',
    label: '12D3',
    image: '/kyyeu/12D3.jpg'
  },
  {
    value: '12D4',
    label: '12D4',
    image: '/kyyeu/12D4.jpg'
  },
  {
    value: '12D5',
    label: '12D5',
    image: '/kyyeu/12D5.jpg'
  },
  {
    value: '12D6',
    label: '12D6',
    image: '/kyyeu/12D6.jpg'
  },
  {
    value: '12SN1',
    label: '12SN1',
    image: '/kyyeu/12SN1.jpg'
  },
  {
    value: '12SN2',
    label: '12SN2',
    image: '/kyyeu/12SN2.jpg'
  }
];
